import EmailValidationError from './EmailValidationError';

export default function validateEmail(email) {
  const emailValidationPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailValidationPattern.test(String(email).toLowerCase())) {
    throw new EmailValidationError();
  }
}
